import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    // welcome page
    {
      path: '/project-gates/:siteId',
      name: 'Welcome Page',
      component: () => import('@/views/auth/WelcomePage'),
    },
    {
      path: '/',
      name: 'Welcome',
      component: () => import('@/views/auth/WelcomePage'),
    },
    {
      path: '/get-started',
      name: 'GetStarted',
      component: () => import('@/views/auth/GetStarted'),
    },
    {
      path: '/login',
      name: 'Login',
      component: () => import('@/views/auth/UseAnotherAccount'),
    },
    {
      path: '/another-account',
      name: 'AnotherAccount',
      component: () => import('@/views/auth/UseAnotherAccount'),
    },
        {
      path: '/otp-reset/:mobileNumber',
      name: 'Link Validation',
      component: () => import('@/views/auth/ResetLinkValidation'),
    },
    {
      path: '/passcode/reset',
      name: 'ResetPasscode',
      component: () => import('@/views/auth/ConfirmMobileNumber'),
    },
    {
      path: '/register',
      name: 'Register',
      component: () => import('@/views/auth/Register'),
    },
    {
      path: '/otp-verification/:mobileNumber',
      name: 'OtpVerification',
      component: () => import('@/views/auth/OtpVerification'),
    },
    {
      path: '/review-details',
      name: 'ReviewDetails',
      component: () => import('@/views/auth/ReviewDetails'),
    },
    {
      path: '/registration-success',
      name: 'RegistrationSuccess',
      component: () => import('@/views/auth/RegistrationSuccess'),
    },
    {
      path: '/downloadapp',
      name: 'DownloadApp',
      component: () => import('@/views/auth/DownloadApp'),
    },
    {
      path: '/dashboard',
      component: () => import('@/views/dashboard/index'),
      meta: {
        requiresAuth: true,
      },
      children: [
        // homepage
        {
          name: 'HomePage',
          path: '/home',
          component: () => import('@/views/dashboard/Pages/Home'),
        },
        {
          name: 'CheckIn',
          path: '/check-in',
          component: () => import('@/views/dashboard/Pages/CheckIn'),
        },
        {
          name: 'Timesheets',
          path: '/timesheets',
          component: () => import('@/views/dashboard/Pages/Timesheets'),
        },
                {
          name: 'Reports',
          path: '/reports',
          component: () => import('@/views/dashboard/Pages/Reports'),
        },
        // Active CheckIns
        {
          name: 'Active CheckIns',
          path: '/active-check-ins',
          component: () => import('@/views/dashboard/Pages/ActiveCheckIn'),
        },
        {
          name: 'Organization Request Accept',
          path: '/organizations/:organizationexternalid/accept-request',
          component: () =>
            import('@/views/dashboard/Pages/OrganizationsRequestAccept'),
        },
        {
          name: 'Organizations',
          path: '/organizations',
          component: () => import('@/views/dashboard/Pages/Organizations.vue'),
        },
        // User Activity
        {
          path: '/activity',
          name: 'User Activity',
          component: () => import('@/views/dashboard/Pages/UserActivities.vue'),
        },
        {
          path: '/profile',
          name: 'User Profile',
          component: () => import('@/views/dashboard/Pages/Profile'),
        },
        {
          path: '/profile/update',
          name: 'User Profile',
          component: () => import('@/views/dashboard/Pages/ProfileUpdate'),
        },
        {
          path: '/documents',
          name: 'Organization Documents',
          component: () => import('@/views/dashboard/Pages/Documents'),
        },
        {
          path: '/attendence',
          name: 'Attendence',
          component: () => import('@/views/dashboard/Pages/Attendence'),
        },
        {
          path: '/projects',
          name: 'Organization Projects',
          component: () =>
            import('@/views/dashboard/Pages/AppUserProjectsPage'),
        },
        {
          path: '/workers',
          name: 'Workers',
          component: () => import('@/views/dashboard/Pages/AppUsers'),
        },
        {
          name: 'CheckoutNotification',
          path: '/notify/checkout',
          component: () =>
            import('@/views/dashboard/Pages/CheckoutNotification'),
        },
        {
          path: '/jobs',
          name: 'Jobs',
          component: () => import('@/views/dashboard/Pages/Jobs'),
        },
        {
          path: '/jobs/:jobId/details',
          name: 'JobDetails',
          component: () => import('@/views/dashboard/Pages/JobDetails'),
        },
        {
          path: '/jobs/:jobId/comments',
          name: 'Comments',
          component: () => import('@/views/dashboard/Pages/JobComments'),
        },
        {
          path: '/invoices',
          name: 'Invoices',
          component: () => import('@/views/dashboard/Pages/Invoices'),
        },
        {
          path: '/invoices/generate',
          name: 'Generate Invoices',
          component: () => import('@/views/dashboard/Pages/InvoiceGeneration'),
        },
        {
          path: '/invoices/draft-generate',
          name: 'Generate Draft Invoices',
          component: () => import('@/views/dashboard/Pages/InvoiceGeneration'),
        },
        {
          path: '/invoices/:id/details',
          name: 'Invoice Details',
          component: () => import('@/views/dashboard/Pages/InvoiceDetails'),
        },
        // Logout
        {
          path: '/logout',
          name: 'Logout',
          component: () => import('@/views/dashboard/Pages/Logout'),
        },
        // Check-In
        {
          path: '/check-in/:siteId/worker',
          name: 'Worker Checkin',
          component: () =>
            import(
              '@/views/dashboard/Pages/CheckInProcess/Worker/WorkerCheckIn'
            ),
        },
        {
          path: '/check-in/:siteId/contractor',
          name: 'Contractor Checkin',
          component: () =>
            import(
              '@/views/dashboard/Pages/CheckInProcess/Contractor/ContractorCheckIn'
            ),
        },
        {
          path: '/check-in/:siteId/visitor',
          name: 'Visitor Checkin',
          component: () =>
            import(
              '@/views/dashboard/Pages/CheckInProcess/Visitor/VisitorCheckIn'
            ),
        },
        {
          path: '/check-in/:siteId/staff',
          name: 'Staff Checkin',
          component: () =>
            import('@/views/dashboard/Pages/CheckInProcess/Staff/StaffCheckIn'),
        },
        {
          name: 'CheckOut',
          path: '/check-out',
          component: () => import('@/views/dashboard/Pages/CheckOut'),
        },
        {
          name: 'Reasone',
          path: '/check-out/reason',
          component: () => import('@/views/dashboard/Pages/Reason'),
        },
        {
          name: 'Checkin Success',
          path: '/check-in/success',
          component: () =>
            import('@/views/dashboard/Pages/CheckInProcess/CheckInSuccessPage'),
        },
        // check out
        {
          path: '/check-out/:siteId/visitor',
          name: 'Visitor Checkout',
          component: () =>
            import(
              '@/views/dashboard/Pages/checkOutProcess/visitor/VisitorCheckOut'
            ),
        },
        {
          path: '/check-out/:siteId/worker',
          name: 'Worker Checkout',
          component: () =>
            import(
              '@/views/dashboard/Pages/checkOutProcess/worker/WorkerCheckOut'
            ),
        },
        {
          path: '/check-out/:siteId/staff',
          name: 'Staff Checkout',
          component: () =>
            import(
              '@/views/dashboard/Pages/checkOutProcess/Staff/StaffCheckOut'
            ),
        },
        {
          path: '/check-out/:siteId/contractor',
          name: 'Contractor Checkout',
          component: () =>
            import(
              '@/views/dashboard/Pages/checkOutProcess/Contractor/ContractorCheckOut'
            ),
        },
        {
          path: '/cost-shift/:siteId/worker',
          name: 'Worker Cost Shift',
          component: () =>
            import('@/views/dashboard/Pages/costShiftProcess/WorkerCostShift'),
        },
        {
          name: 'Costshift Success',
          path: '/cost-shift/success',
          component: () =>
            import(
              '@/views/dashboard/Pages/costShiftProcess/CostShiftSuccessPage'
            ),
        },
      ],
    },

    // Device Routers
    {
      path: '/device',
      name: 'DeviceLogin',
      component: () => import('@/views/device/auth/Login'),
    },
    {
      path: '/device/check-in-or-check-out',
      name: 'DeviceCheckInCheckOut',
      component: () => import('@/views/device/dashboard/pages/checkInCheckOut'),
    },
    {
      path: '/device/select-user',
      name: 'DeviceSelectUser',
      component: () => import('@/views/device/dashboard/pages/selectUser'),
    },
    {
      path: '/device/user-login',
      name: 'DeviceUserLogin',
      component: () => import('@/views/device/dashboard/pages/appUserLogin'),
    },
    {
      path: '/device/select-project',
      name: 'DeviceSelectProject',
      component: () => import('@/views/device/dashboard/pages/listProjects'),
    },
    {
      path: '/device/check-out-or-cost-shift',
      name: 'DeviceCheckOutCostShift',
      component: () =>
        import('@/views/device/dashboard/pages/checkOutCostShift'),
    },
    {
      path: '/device/cost-shift',
      name: 'CostShift',
      component: () => import('@/views/device/dashboard/pages/costShift'),
    },
    // {
    //   path: '/passcode/:userId/:linkId',
    //   name: 'Link Validation',
    //   component: () => import('@/views/auth/ResetLinkValidation'),
    // },
    {
      name: 'New Passcode',
      path: '/passcode/update/:number',
      component: () => import('@/views/auth/ResetPasscode'),
    },
    // Not Using
    {
      path: '/qr-scan/:organization_id/:digi_board_id',
      name: 'QrScanHome',
      component: () => import('@/views/qrscan/LandingPage'),
    },
    // Alert Response
    {
      path: '/alerts/responses/:responseId',
      name: 'Alert Response',
      component: () => import('@/views/dashboard/Pages/AlertMarkSafe'),
    },
    // About
    {
      path: '/about',
      name: 'About',
      component: () => import('@/components/About'),
    },
    // Unknown
    {
      path: '/*',
      name: 'Not Found',
      component: () => import('@/views/app/404.vue'),
    },
  ],
});

router.beforeEach((to, from, next) => {
  const loggedIn = localStorage.getItem('user');

  if (to.matched.some((record) => record.meta.requiresAuth) && !loggedIn) {
    next('/');
    return;
  }
  const org = JSON.parse(localStorage.getItem('selectedOrganization'));

  if (to.path.startsWith('/invoices') || to.path.startsWith('/workers') || to.path.startsWith('/attendence') || to.path.startsWith('/projects')) {
    if (!org || org.active === false) {
      next('/home');
      return;
    }
  }
  next();
});

export default router;
